<template>
  <BaseModal
    v-if="show"
    title="Positionen verwalten"
    min-height="none"
    @close="close"
  >
    <template #content>
      <p class="mb-8">
        Hier können Sie per Drag and Drop die Zeilen in die gewünschte
        Reihenfolge bringen.
      </p>
      <div
        class="columnOrder"
        :class="{ grab }"
        @mousedown="grab = true"
        @mouseup="grab = false"
      >
        <Container :key="key" @drop="onDrop">
          <Draggable v-for="column in draggableColumns" :key="column.index">
            <div class="draggable-item">
              <span>{{ column.alias ?? column.key }}</span>
              <i class="fa-light fa-grip-lines" />
            </div>
          </Draggable>
        </Container>
      </div>
      <BaseButton
        outlined
        rounded
        highlight
        size="xs"
        class="w-fit m-auto"
        @click.native="save"
      >
        Änderungen übernehmen
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script>
import { Container, Draggable } from 'vue-dndrop';

export default {
  name: 'RowOrder',
  components: {
    Container,
    Draggable,
  },
  props: {
    columns: Array,
    rows: String,
    show: Boolean,
  },
  data() {
    return {
      draggableColumns: [],
      key: 0,
      grab: false,
    };
  },
  watch: {
    async columns() {
      if (this.rows) {
        const response = await axios.get(this.rows);
        this.draggableColumns = response?.data?.list ?? [];
      }
    },
  },
  methods: {
    applyDrag: (arr, dragResult) => {
      const { removedIndex, addedIndex, payload } = dragResult;
      if (removedIndex === null && addedIndex === null) return arr;

      const result = [...arr];
      let itemToAdd = payload;

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }

      return result;
    },
    onDrop(dropResult) {
      this.draggableColumns = this.applyDrag(this.draggableColumns, dropResult);
    },
    save() {
      this.$emit('change', this.draggableColumns);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.card) {
  width: 80%;
  min-width: 800px;
  z-index: 999;
  position: relative;
  min-height: 300px;
}

.columnOrder {
  margin-bottom: 30px;
  width: 100%;
  overflow: auto;
  height: 350px;
  max-height: 100%;
  cursor: grab;
}

.dndrop-container {
  height: 100%;
}

.dndrop-draggable-wrapper {
  height: 42px;
  margin-bottom: 10px;
  .draggable-item {
    height: 100%;
    padding: 15px 22px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &:last-child .draggable-item {
    margin-right: 0;
  }
}

.grab {
  cursor: grabbing;
}
</style>
